'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var EQUALS = exports.EQUALS = 'EQUALS';
var STARTS_WITH = exports.STARTS_WITH = 'STARTS_WITH';
var CONTAINS = exports.CONTAINS = 'CONTAINS';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/constants/TargetingRuleMatchTypes.js
// module id = 911
// module chunks = 2 3